export class LabelTextConfig {
}
LabelTextConfig.color = 0xFF4DDD;
//# sourceMappingURL=LabeltextConfig.js.map